// extracted by mini-css-extract-plugin
export default {"wrapper":"page-wrapper_wrapper__Sdnyl","centerVertically":"page-wrapper_centerVertically__-gIic","content":"page-wrapper_content__5L6RI"};